import { useState, useEffect } from 'react'
import SpektrixFetcher from '@lib/spektrix/fetcher'

// Global basket state - shared across all components
const globalBasketState = {
  data: null,
  error: null,
  isLoading: false,
  fetchPromise: null,
  listeners: new Set()
}

// Notify all listeners of state change
const notifyListeners = () => {
  globalBasketState.listeners.forEach(listener => listener())
}

// Fetch basket data with deduplication
const fetchBasket = async () => {
  // If already fetching, return existing promise
  if (globalBasketState.fetchPromise) {
    return globalBasketState.fetchPromise
  }

  globalBasketState.isLoading = true
  globalBasketState.error = null
  notifyListeners()

  globalBasketState.fetchPromise = SpektrixFetcher('/basket')
    .then(data => {
      globalBasketState.data = data
      globalBasketState.isLoading = false
      globalBasketState.error = null
      globalBasketState.fetchPromise = null
      notifyListeners()
      return data
    })
    .catch(err => {
      globalBasketState.error = err
      globalBasketState.isLoading = false
      globalBasketState.fetchPromise = null
      notifyListeners()
      throw err
    })

  return globalBasketState.fetchPromise
}

// Hook to use global basket state in React components
const useBasketModel = () => {
  const [, forceUpdate] = useState({})

  useEffect(() => {
    // Subscribe to changes
    const listener = () => forceUpdate({})
    globalBasketState.listeners.add(listener)

    // Cleanup
    return () => {
      globalBasketState.listeners.delete(listener)
    }
  }, [])

  return {
    data: globalBasketState.data,
    error: globalBasketState.error,
    isLoading: globalBasketState.isLoading,
    fetchBasket,
    mutate: fetchBasket
  }
}

// Auto-fetch basket data when module loads (before any components mount)
// This ensures only ONE request is made
fetchBasket().catch(() => {
  // Error is stored in globalBasketState.error
})

export default useBasketModel
